var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default"),_c('div',{class:{hasMore: _vm.hasMore},attrs:{"i-class":"text-muted pt-5 text-center"},on:{"click":_vm.onLoadMore}},[_vm._v(" "+_vm._s(_vm.textContent)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }